import { createAction } from '@reduxjs/toolkit';
import { RequestWithId } from 'types';

import profileActionTypes from './actionTypes';

export const getProfileById = createAction<RequestWithId>(profileActionTypes.GET_PROFILE);
export const follow = createAction<RequestWithId>(profileActionTypes.FOLLOW);
export const unfollow = createAction<RequestWithId>(profileActionTypes.UNFOLLOW);
